@if (demographicsDataService.inhabitantDemographicVisibleSection()) {
    <div>
        @if (demographicsDataService.inhabitantDemographicIsLoading()) {
            <div class="header-wrapper">
                <div class="column-center" style="padding: 25px 0">
                    <ev-logo-loader width="70px" />
                </div>
            </div>
        } @else {
            <div>
                @switch (demographicsDataService.inhabitantDemographicVisibleSection()) {
                    @case (visibleSection.showData) {
                        @if (inhabitantDemographicsTotal()) {
                            <div>
                                <div class="header-wrapper">
                                    @if (inhabitantDemographicsTotal().shouldShow) {
                                        <div class="column column-centered separator marginalized">
                                            <div class="uppercase-text primary-color">Innbyggere</div>
                                            <div class="uppercase-text secondary-color">over 18 år</div>
                                            <div class="extra-big-number">{{ inhabitantDemographicsTotal().numPersons | thousandize }}</div>
                                        </div>
                                        <div class="row marginalized">
                                            <div class="column column-half column-centered">
                                                <div class="uppercase-text primary-color">Alder</div>
                                                <div class="uppercase-text secondary-color">median</div>
                                                <div class="big-number">{{ inhabitantDemographicsTotal().medianAgeNow | thousandize }}</div>
                                            </div>
                                            <div class="column column-half column-centered">
                                                <div class="uppercase-text primary-color">Inntekt</div>
                                                <div class="uppercase-text secondary-color">snitt</div>
                                                <div class="big-number">{{ inhabitantDemographicsTotal().averageIncome | thousandize }}</div>
                                            </div>
                                        </div>
                                    }
                                    @if (!inhabitantDemographicsTotal().shouldShow) {
                                        <div class="column column-centered marginalized">
                                            <div class="info-icon"></div>
                                            <div class="info-text">Ikke nok datapunkter til å vise statistikk. Prøv å utvide det valgte området i kartet.</div>
                                        </div>
                                    }
                                    @if (inhabitantDemographicsTotal().shouldShow) {
                                        <div class="row">
                                            <div class="secondary-color explanation-text marginalized">
                                                Basert på aggregerte tall og må ikke tolkes som presis informasjon om enkeltpersoner/husholdninger.
                                            </div>
                                        </div>
                                    }
                                    <div class="extra-info-wrapper" (click)="showMoreInfo = !showMoreInfo" [class.extra-info-active]="showMoreInfo">
                                        <div class="extra-info-header">
                                            <div class="extra-info-header-text">Mer info</div>
                                            <div class="expander-icon"></div>
                                        </div>
                                        @if (showMoreInfo) {
                                            <div class="extra-info-text">
                                                Estimert inntekt er basert på grupper på minst fire personer med samme alder, samme kjønn og samme grunnkrets.
                                                Tilordnet gjennomsnitt av ligningsinntekt i gruppen til hvert enkelt gruppemedlem<br />Kilde: DataFactory<br /><br />
                                                <div class="sub-header">Beskrivelse av livsfasene</div>
                                                <br />
                                                Segmenteringen er ikke faktabasert, men angir en sannsynlig livsfase basert på mange variabler.<br />Kilde:
                                                DataFactory<br /><br />
                                                <div class="sub-header">Ungdom / student</div>
                                                <br />
                                                Alle under 25 år, samt de under 30 år som har inntekt som er «for lav til å kunne leve av» <br /><br />
                                                <div class="sub-header">Singel</div>
                                                <br />
                                                Har inntekt, lever alene uten barn, og er mellom 25 og 50 år<br /><br />
                                                <div class="sub-header">Par uten barn</div>
                                                <br />
                                                Par under 50 år uten barn<br /><br />
                                                <div class="sub-header">Småbarnsfamilie</div>
                                                <br />
                                                Par med barn under 6 år<br /><br />
                                                <div class="sub-header">Etablert barnefamilie</div>
                                                <br />
                                                Par med barn i skolealder (6-18 år)<br /><br />
                                                <div class="sub-header">Enslig forsørger</div>
                                                <br />
                                                Enslige med barn i alderen 0-18 år<br /><br />
                                                <div class="sub-header">Middelaldrende par</div>
                                                <br />
                                                Par i alderen 50-67 år uten barn<br /><br />
                                                <div class="sub-header">Middelaldrende enslig</div>
                                                <br />
                                                Enslige i alderen 50-67 år uten barn<br /><br />
                                                <div class="sub-header">Senior par</div>
                                                <br />
                                                Par i alderen 67 år og eldre<br /><br />
                                                <div class="sub-header">Senior enslig</div>
                                                <br />
                                                Enslige i alderen 67 år og eldre<br /><br />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        @if (inhabitantDemographics()) {
                            <div>
                                @for (inhab of inhabitantDemographics(); track inhab; let first = $first; let last = $last) {
                                    <div class="mini-inhabitants-wrapper" [class.first]="first" [class.last]="last">
                                        <div class="column column-half">
                                            <div class="phase-of-life-text primary-color">{{ inhab.phaseOfLifeHeader }}</div>
                                            @if (inhab.phaseOfLifeDetail) {
                                                <div class="phase-of-life-text secondary-color">{{ inhab.phaseOfLifeDetail }}</div>
                                            }
                                            <div class="share-of-total">{{ inhab.shareOfTotal | percent: "1.0-1" }}</div>
                                        </div>
                                        <div class="column column-half column-left-border">
                                            <div class="row">
                                                <div class="secondary-color">Antall</div>
                                                <div class="primary-color">{{ inhab.numPersons | thousandize }}</div>
                                            </div>
                                            <div class="row">
                                                <div class="secondary-color">Alder median</div>
                                                <div class="primary-color">{{ inhab.medianAgeNow | thousandize }}</div>
                                            </div>
                                            <div class="row">
                                                <div class="secondary-color">Inntekt</div>
                                                <div class="primary-color">{{ inhab.averageIncome | thousandize }}</div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div class="row">
                                    @if (!showAll() && totalEntries > minEntriesToShow) {
                                        <div><div class="button" (click)="showAllEntries()">Se flere</div></div>
                                    }
                                </div>
                            </div>
                        }
                    }
                    @case (visibleSection.zoomIn) {
                        <div class="header-wrapper zoom-in-text">Zoom inn for &#229; vise statistikk</div>
                    }
                }
            </div>
        }
    </div>
} @else {
    <div class="header-wrapper zoom-in-text">Zoom inn for &#229; vise statistikk</div>
}
